import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_movewithtony/artifacts/0c98olj8_c413a017a11bcba_file_000000009aec61fba9d62adbd361f5c9_wm.png";

const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Tony Moves It" 
                className="h-12 w-12 object-contain rounded-lg"
              />
              <span className="text-xl font-bold font-['Barlow_Condensed']">TONY MOVES IT</span>
            </div>
            <p className="text-slate-400 mb-4">
              Your trusted local movers in Cornwall and SDG. Fully insured, 
              professional service with 10+ years of experience.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61573945635262" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-lg hover:bg-[#0047AB] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold font-['Barlow_Condensed'] mb-6 uppercase">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Tony
                </Link>
              </li>
              <li>
                <Link to="/quote" className="text-slate-400 hover:text-white transition-colors">
                  Free Quote
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-slate-400 hover:text-white transition-colors">
                  Book a Move
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold font-['Barlow_Condensed'] mb-6 uppercase">Services</h3>
            <ul className="space-y-3">
              <li className="text-slate-400">Residential Moving</li>
              <li className="text-slate-400">Commercial Moving</li>
              <li className="text-slate-400">Piano & Specialty Items</li>
              <li className="text-slate-400">Local & Long Distance</li>
              <li className="text-slate-400">Packing Services</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold font-['Barlow_Condensed'] mb-6 uppercase">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:613-362-8180" 
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5 text-[#0047AB]" />
                  <span>613-362-8180</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:tonymovesit@hotmail.com" 
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5 text-[#0047AB]" />
                  <span>tonymovesit@hotmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-[#0047AB] mt-1" />
                <span>Cornwall & SDG, Ontario, Canada</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Tony Moves It. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Fully Insured | Licensed Local Movers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
